<ng-container *transloco="let t">
  @if (attachmentProps$ | async; as props) {
    <div class="flex flex-col gap-2">
      <pxc-attachment-filters />

      @if ((isArchived$ | async) === false) {
        <pxc-attachment-drag-and-drop (files)="uploadFiles(props, $event)" />
      }

      @if (uploadingFiles$ | async; as uploadingFiles) {
        <pxc-uploading-file-list [uploadingFiles]="uploadingFiles" (retryUpload)="retryUpload(props, $event)" />
      }

      @if (attachments$ | async; as attachments) {
        <pxc-attachment-list [attachments]="attachments" />
      } @else {
        <ng-container *ngTemplateOutlet="loading" />
      }
    </div>
  } @else {
    <ng-container *ngTemplateOutlet="loading" />
  }

  <ng-template #loading>
    <div class="my-4">
      <pxc-loader data-testid="loading">{{ t('Chargement des fichiers ...') }}</pxc-loader>
    </div>
  </ng-template>
</ng-container>
